export const START_DATE = 'Start date'
export const START_TIME = 'Start time'

export const END_DATE = 'End date'
export const END_TIME = 'End time'